import { render } from "./PageFilter.vue?vue&type=template&id=426f9637"
import script from "./PageFilter.vue?vue&type=script&lang=js"
export * from "./PageFilter.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__